import React from "react";

import { ButtonProps } from "./Button.props";

export const Button = ({
	children,
	appearance,
	icon = null,
	className = "",
	width = "max",
	paddingX = "px-8",
	paddingY = "py-[10px]",
	center = true,
	grid = "grid grid-cols-maxTwo gap-2",
	...props
}: ButtonProps): JSX.Element => {
	return (
		<button
			className={`${
				appearance === "main"
					? "bg-mainColor text-white"
					: appearance === "white"
					? "bg-shadeColor text-mainFirstColor hover:text-white border-none hover:bg-mainSecondColorHover"
					: appearance === "black"
					? "bg-mainFirstColor text-white border-none"
					: appearance === "red"
					? "bg-redColor text-white border-none"
					: appearance === "ghost"
					? "bg-white text-mainFirstColor border border-strokeColor"
					: appearance === "disabled"
					? "bg-grayTwoColor text-white border border-grayTwoColor"
					: appearance === "low"
					? "bg-lowOpacity text-mainColor"
					: ""
			} 
			w-${width}
			${
				center
					? "place-content-center place-items-center"
					: "place-content-start place-items-center"
			}
				${paddingY} ${paddingX} cursor-pointer rounded-md shadow-xs ${
				icon && grid
			} ${className}  text-base font-light transition-all duration-200`}
			{...props}
		>
			{icon !== null && <>{icon}</>}
			{children}
		</button>
	);
};
